module.exports = __webpack_public_path__ + "static/media/bfile-renter.7af09506.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-renter.svg
// module id = 205
// module chunks = 0